<template>
  <v-row dense no-gutters>
    <v-col v-for="(item,i) in items" :cols="cols" :key="i">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle style="white-space:inherit;">{{formData[item.code]==null?'N/A':formData[item.code]}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" class="text-right" v-if="downloadAble">
      <v-btn class="mr-4" color="teal" dark @click="onDownloadOrderInvoice">发票下载</v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { downloadOrderInvoice } from '@/plugins/api'
export default {
  props: ['formData'],
  data () {
    return {
      cols: 4,
      items: [
        { title: '订单号', code: 'tradeNo' },
        { title: '金额', code: 'amount' },
        { title: '积分值', code: 'pointAmount' },
        { title: '支付时间', code: 'payDtm' },
        { title: '是否申请发票', code: 'ivcFlag' },
        { title: '发票申请时间', code: 'ivcApplyDtm' },
        { title: '是否已开发票', code: 'ivcMakeFlag' },
        { title: '发票开具时间', code: 'ivcMakeDtm' },
        { title: '发票号', code: 'ivcNo' },
        { title: '快递单号', code: 'ivcTranNo' }
      ]
    }
  },
  computed: {
    downloadAble () {
      return this.formData.ivcFlag && this.formData.ivcMakeFlag
    }
  },
  methods: {
    onDownloadOrderInvoice () { // 下载发票
      downloadOrderInvoice(this.formData.id)
    }
  }
}
</script>